module.exports = __webpack_public_path__ + "static/don9-aea36a07df68eb42ed3ff1a04f03a6ec.jpg";